import classnames from 'classnames';
import * as React from 'react';

import { Icon } from '@ao-internal/components-react';

import TailIcon from '../assets/icons/Tail';
import { ChatMode } from '../store';

export interface ToggleButtonVariant {
	type?: 'lozenge';
	bgColor?: string;
}

interface ToggleButtonProps
	extends React.DetailedHTMLProps<
		React.ButtonHTMLAttributes<HTMLButtonElement>,
		HTMLButtonElement
	> {
	isOpen?: boolean;
	variant?: ToggleButtonVariant;
	chatMode?: ChatMode;
}

// const defaultVariant: ToggleButtonVariant = {};

export const ToggleButton = React.forwardRef<
	HTMLButtonElement,
	ToggleButtonProps
>(({ isOpen, variant, chatMode, ...props }, ref) => {
	// const [variantConfig] = React.useState({
	// 	...defaultVariant,
	// 	...variant,
	// });

	return (
		<button
			ref={ref}
			data-tag-name="toggle cta"
			data-tag-action={isOpen ? 'close' : 'open'}
			data-testid="toggle-chatbot"
			type="button"
			aria-label={isOpen ? 'Close AO Assistant' : 'Open AO Assistant'}
			className={classnames(
				'c-chat-toggle-button c-chat-toggle-button-lozenge fixed left-0 md:left-auto md:right-0 bottom-0 justify-center items-center cursor-pointer rounded-full ml-4 md:ml-auto md:mr-5 text-white bg-transparent p-0',
				{
					flex: !isOpen,
					'hidden md:flex c-chat-toggle-button-lozenge--open': isOpen,
				}
			)}
			{...props}
		>
			{isOpen ? (
				<React.Fragment>
					<span className="sr-only">Close AO Assistant</span>
					<Icon
						icon="close"
						className="c-chat-toggle-button-lozenge__open-icon-fg c-icon relative z-20 stroke-0"
						style={{ fontSize: '29px', top: '-1px' }}
					/>
					<span className="c-chat-toggle-button-lozenge__open-icon-bg bg-darkgreen absolute inset-0 block -translate-x-1/2 rounded-full" />
				</React.Fragment>
			) : (
				<React.Fragment>
					<span className="sr-only">Open AO Assistant</span>
					<span className="c-chat-toggle-button-lozenge__lozenge relative z-30 flex items-center justify-between w-full text-sm rounded-full">
						<span className="font-headline lg:text-lg md:text-base lg:mr-2 flex justify-end flex-grow mr-1 text-sm font-bold leading-none tracking-wider text-white">
							Chat
						</span>
						<span
							className="md:hidden bg-ongreen flex items-center justify-center rounded-full"
							style={{
								width: '48px',
								height: '48px',
							}}
						>
							{/* mobile icon */}
							<Icon icon="ao-logo" size="2x" className="text-white" />
						</span>
						<span
							className="sm:hidden md:flex lg:hidden bg-ongreen items-center justify-center hidden rounded-full"
							style={{
								width: '61px',
								height: '61px',
							}}
						>
							{/* tablet icon */}
							<Icon
								icon="ao-logo"
								className="text-white"
								style={{ fontSize: '2.5em' }}
							/>
						</span>
						<span
							className="lg:flex bg-ongreen items-center justify-center hidden rounded-full"
							style={{
								width: '76px',
								height: '76px',
							}}
						>
							{/* desktop icon */}
							<Icon icon="ao-logo" size="3x" className="text-white" />
						</span>
					</span>
					<span className="c-chat-toggle-button-lozenge__tail bg-darkgreen absolute inset-0 z-20 rounded-full">
						<span
							className="md:hidden absolute"
							style={{
								bottom: '-4px',
								right: '7px',
							}}
						>
							{/* mobile */}
							<TailIcon
								className="text-ongreen block h-auto"
								style={{
									width: '11px',
								}}
							/>
						</span>
						<span
							className="md:block lg:hidden absolute hidden"
							style={{
								bottom: '-4px',
								right: '7px',
							}}
						>
							{/* tablet */}
							<TailIcon
								className="text-ongreen block h-auto"
								style={{
									width: '14px',
								}}
							/>
						</span>
						<span
							className="lg:block absolute hidden"
							style={{
								bottom: '-4px',
								right: '8px',
							}}
						>
							{/* desktop */}
							<TailIcon
								className="text-ongreen block h-auto"
								style={{
									width: '17px',
								}}
							/>
						</span>
					</span>
				</React.Fragment>
			)}

			{chatMode === ChatMode.LiveChat && !isOpen && (
				<span
					data-testid="live-chat-indicator"
					className="c-chat-toggle-button-lozenge__live-chat-indicator bg-cta-action absolute z-30 block border-2 border-white border-solid rounded-full"
				/>
			)}
		</button>
	);
});

export default ToggleButton;
